export const smsApi = (http) => {
  return {
    subscribe: async (source) => {
      return http.post('/api/sms-subscribe/', {
        source,
      });
    },
  };
};
